import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}

export const actions = {
	list({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`/examination/paper/list`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  save({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/examination/paper/save`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findById({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/examination/paper/findById?id=${params.id}`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  findPaperQuestion({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/examination/paper/findPaperQuestion?id=${params.id}`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  
  remove({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`/examination/paper/remove?id=${params.id}`)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  batchRemove({ commit }, data) {
		return new Promise((resolve, reject) => {
			axios.post(`/examination/paper/batchRemove`, data)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
}
